import { times } from 'lodash-es';
import React, { useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';
import { SettingEvent } from '../../../../../interfaces/merchants/resources/books';
import Select from '../../../../../atoms/Select';
import LabeledContainer from '../../../../common/LabeledContainer';
import BooksMenu from '../BooksMenu';

interface Props {
  settings: SettingEvent;
  attendees: number | undefined;
  onChangeAttendees: (n: number) => void;
  withExpressFlow: boolean;
}

const InputBookingEventDateTimeCommonHeader: React.FC<Props> = (props) => {
  const {
    settings: {
      name,
      multipleAttendees: { allowed, max },
      attendeesCustomLabel,
    },
    attendees,
    withExpressFlow,
    onChangeAttendees,
  } = props;
  const intl = useIntl();

  const handleChangeAttendees = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      const {
        currentTarget: { value },
      } = e;
      const attendees = parseInt(value, 10);
      onChangeAttendees(attendees);
    },
    [onChangeAttendees],
  );

  const attendeesTitleLabel = useMemo(() => {
    let returnValue = attendeesCustomLabel
      ? attendeesCustomLabel
      : intl.formatMessage({
          id: 'books.formsLabel.numberOfPeopleToBook',
        });

    returnValue +=
      '  ※' + intl.formatMessage({ id: 'books.formsLabel.elementIsEditable' });

    return returnValue;
  }, [attendeesCustomLabel, intl]);

  const attendeesNum = (n: number) =>
    attendeesCustomLabel ? `${n}` : `${n}人`;

  return (
    <div>
      {!withExpressFlow && (
        <LabeledContainer
          label={intl.formatMessage({
            id: 'books.formsLabel.selectedBooks',
          })}
          paddingTop={true}
          contentsPadding={true}
        >
          <BooksMenu menuName={name} />
        </LabeledContainer>
      )}
      <div>
        {allowed && (
          <LabeledContainer label={attendeesTitleLabel} paddingTop={true}>
            <Select
              name="attendees"
              value={attendees}
              onChange={handleChangeAttendees}
              selected={attendees !== undefined}
            >
              {times(max).map((n) => (
                <option key={n} value={n + 1}>
                  {attendeesNum(n + 1)}
                </option>
              ))}
            </Select>
          </LabeledContainer>
        )}
      </div>
    </div>
  );
};

export default InputBookingEventDateTimeCommonHeader;
